<template>
  <div class="gallery">
    <Photo
      v-for="(photo, index) in list"
      :photo="photo"
      :key="photo.id || index"
      @delete="$emit('delete', $event)"
    />
    <DropBox
      multiple
      accepted-only
      accept=".jpg,.jpeg,.bmp,.png,.webp"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import Photo from '@/components/galery/Photo.vue';
import DropBox from '@/components/DropBox.vue';

export default {
  name: 'Gallery',
  components: { Photo, DropBox },
  props: { list: { type: Array, required: true } },
};
</script>

<style lang="scss" scoped>
.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
}

::v-deep .photo,
::v-deep .custom-file {
  width: 100%;
  min-width: 0;
  height: 160px;
  min-height: 160px;
}
</style>
